
import ClauseComponent from './Clauses/ClauseComponent';
import ClausesComponentVM from './Clauses/ClausesComponentVM';
import SingleClauseComponentVM from './Clauses/SingleClauseComponentVM';
import './platform-styles.scss';


const entPlatformComponentMap = {
    ClauseComponent: { component: 'ClauseComponent' },
    ClausesComponentVM: { component: 'ClausesComponentVM' },
    SingleClauseComponentVM: { component: 'SingleClauseComponentVM' }
};

const entPlatformComponents = {
    ClauseComponent,
    ClausesComponentVM,
    SingleClauseComponentVM,
};

export {
    ClauseComponent,
    ClausesComponentVM,
    SingleClauseComponentVM,
    // for Jutro
    entPlatformComponentMap,
    entPlatformComponents,
};
